import axios from 'axios';

const API_BASE_URL = '/api';

// ============================================
// PCA Plot
// ============================================
export const fetchPcaPlot = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/plots/pca_plot`);
    return response.data;
  } catch (error) {
    console.error('Error fetching PCA plot data:', error);
    throw error;
  }
};

// ============================================
// Cross-Sell Recommendations
// ============================================
export const getCrossSellRecommendations = async (companyName) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/recommendations/cross_sell`, {
      company_name: companyName
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching cross-sell recommendations:', error);
    throw error;
  }
};

// ============================================
// Data Inputs
// ============================================
export const fetchDataInputs = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/data/inputs`);
    return response.data;
  } catch (error) {
    console.error('Error fetching data inputs:', error);
    throw error;
  }
};

// ============================================
// Box Plots - Customer Market Segment
// ============================================
export const fetchCustomerMarketSegmentBoxPlot = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/plots/box_plot/customer_market_segment`);
    return response.data;
  } catch (error) {
    console.error('Error fetching customer market segment box plot:', error);
    throw error;
  }
};

export const fetchSalesRevenueBoxPlot = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/plots/box_plot/sales_revenue`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sales revenue box plot:', error);
    throw error;
  }
};

export const fetchPremisesMeasurementBoxPlot = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/plots/box_plot/premises_measurement`);
    return response.data;
  } catch (error) {
    console.error('Error fetching premises measurement box plot:', error);
    throw error;
  }
};

// ============================================
// Box Plots - Vertical Market Segment
// ============================================
export const fetchVerticalMarketSegmentBoxPlot = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/plots/box_plot/vertical_market_employees`);
    return response.data;
  } catch (error) {
    console.error('Error fetching vertical market segment box plot:', error);
    throw error;
  }
};

export const fetchVerticalSalesRevenueBoxPlot = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/plots/box_plot/vertical_sales_revenue`);
    return response.data;
  } catch (error) {
    console.error('Error fetching vertical sales revenue box plot:', error);
    throw error;
  }
};

export const fetchVerticalPremisesMeasurementBoxPlot = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/plots/box_plot/vertical_premises`);
    return response.data;
  } catch (error) {
    console.error('Error fetching vertical premises measurement box plot:', error);
    throw error;
  }
};